

import { Action } from '@ngrx/store';


export enum EUOTActions {
    GetUOT = '[UOT] Get UOT',
    GetUOTDetails = '[UOT] Set UOT Details',
    AddUOT = '[UOT] Add UOT',
    // EditUOT = '[UOT] Edit UOT',
    SetUOTSuccess = 'Set UOT Success',
    SetUOTError = 'Set UOT Error',
    GetAllProductTypes = '[UOT] Get All Product Types',
    GetAllProductTypesSuccess = '[UOT] Get All Product Types Success',
    GetAllProductTypesError = '[UOT] Get All Product Types Error',
    AddProductType = '[UOT] Add Product Type',
    GetAddProductTypeSuccess = '[UOT] Add Product Type Success',
    GetAddProductTypeError = '[UOT] Add Product Type Error',
    EditProductType = '[UOT] Edit Product Type',
    GetEditProductTypeSuccess = '[UOT] Edit Product Type Success',
    GetEditProductTypeError = '[] Edit Product Type Error',


}

export class GetUOT implements Action {
    public readonly type = EUOTActions.GetUOT;
    constructor() {
    }
}

export class GetUOTDetails implements Action {
    public readonly type = EUOTActions.GetUOTDetails;
    constructor(public payload: any) {
    }
}

export class AddUOT implements Action {
    public readonly type = EUOTActions.AddUOT;
    constructor(public payload: any) {
    }
}

export class SetUOTSuccess implements Action {
    public readonly type = EUOTActions.SetUOTSuccess;
    constructor(public payload: any, public from: any) {
    }
}

export class SetUOTError implements Action {
    public readonly type = EUOTActions.SetUOTError;
    constructor(public payload: any, public from: any) {
    }
}
export class GetAllProductTypes implements Action {
    public readonly type = EUOTActions.GetAllProductTypes;
    constructor(public payload: any) {
    }
}
export class GetAllProductTypesSuccess implements Action {
    public readonly type = EUOTActions.GetAllProductTypesSuccess;
    constructor(public payload: any) {
    }
}
export class GetAllProductTypesError implements Action {
    public readonly type = EUOTActions.GetAllProductTypesError;
    constructor(public payload: any) {
    }
}
export class AddProductType implements Action {
    public readonly type = EUOTActions.AddProductType;
    constructor(public payload: any) {
    }
}
export class GetAddProductTypeSuccess implements Action {
    public readonly type = EUOTActions.GetAddProductTypeSuccess;
    constructor(public payload: any) {
    }
}
export class GetAddProductTypeError implements Action {
    public readonly type = EUOTActions.GetAddProductTypeError;
    constructor(public payload: any) {
    }
}
export class EditProductType implements Action {
    public readonly type = EUOTActions.EditProductType;
    constructor(public payload: any) {
    }
}
export class GetEditProductTypeSuccess implements Action {
    public readonly type = EUOTActions.GetEditProductTypeSuccess;
    constructor(public payload: any) {
    }
}
export class GetEditProductTypeError implements Action {
    public readonly type = EUOTActions.GetEditProductTypeError;
    constructor(public payload: any) {
    }
}
export type UOTAction =  GetUOT | GetUOTDetails | SetUOTSuccess | SetUOTError | AddUOT|
GetAllProductTypes|GetAllProductTypesSuccess|GetAllProductTypesError|
AddProductType|GetAddProductTypeSuccess|GetAddProductTypeError| EditProductType|
GetEditProductTypeSuccess | GetEditProductTypeError;